// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ce76851b","239":"3665c902","453":"4c01e99f","732":"7d8f08c3","977":"1aea54c8"}[chunkId] + ".chunk.js";
};